import { useCallback } from 'react';

import clsx from 'clsx';

import { Check } from '../Icons';

import styles from './ImageTile.module.scss';

type ImageTileProps = {
  /**
   *  ImageTile image src
   */
  imageSrc: string;

  /**
   * The image id.
   */
  id: string;

  /**
   * The callback to handle the click.
   */
  onClick?: (id: string) => void;

  /**
   * The additional class names for the container div.
   */
  className?: string;

  /**
   *  If ImageTile is checked
   */
  selected?: boolean;

  /**
   *  ImageTile image alt
   */
  imageAlt?: string;
};

export const ImageTile = ({ id, selected = false, imageSrc, imageAlt = '', onClick, className }: ImageTileProps) => {
  const handleClick = useCallback(() => {
    onClick?.(id);
  }, [onClick, id]);

  const Tag = onClick ? 'button' : 'div';

  return (
    <Tag
      className={clsx(styles.container, selected && styles.selected, className)}
      role="checkbox"
      aria-checked={selected}
      onClick={handleClick}
    >
      <div className={styles.icon} aria-hidden={!selected}>
        <Check aria-label="Selected" role="img" />
      </div>
      <img src={imageSrc} alt={imageAlt} />
    </Tag>
  );
};
